<template>
    <div class="container-fluid default-dashboard">
        <div class="card">
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <h5>User List</h5>
                    <button class="btn btn-primary" @click="openModal()">
                        <i class="fa fa-plus"></i> Add User
                    </button>
                </div>
            </div>
            <div class="card-body">
                <DataTable :headers="headers" :items="users" :loading="loading" :total="total" :params="params"
                    @update:params="updateParams">
                    <template #item.avatarurl="{ item }">
                        <img :src="item.avatarurl" alt="Avatar" class="img-fluid rounded-circle" width="50">
                    </template>
                    <template #item.role="{ item }">
                        {{ item?.role?.description }}
                    </template>
                    <template #item.actions="{ item }">
                        <button class="btn btn-sm btn-warning me-2" @click="editUser(item as any)">
                            <i class="fa fa-edit"></i>
                        </button>
                        <button class="btn btn-sm btn-danger" @click="deleteUser(item as any)">
                            <i class="fa fa-trash"></i>
                        </button>
                    </template>
                </DataTable>
            </div>
        </div>
    </div>

    <div class="modal fade bd-example-modal-lg" id="userModal" tabindex="-1" ref="modalRef"
        aria-labelledby="userModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <h3 class="modal-header justify-content-center border-0">{{ modalTitle }}</h3>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12 mb-2">
                            <div class="text-center mb-4">
                                <img :src="form.avatarurl || 'https://via.placeholder.com/120'" alt="Profile Picture"
                                    class="rounded-circle" width="120" height="120" />
                            </div>
                        </div>
                        <div class="col-md-6 mb-2">
                            <label class="form-label col-form-label">Role</label>
                            <select class="form-select" v-model="form.role">
                                <option value="">Choose Role</option>
                                <option v-for="item in roleOptions" :key="item.ID" :value="item">
                                    {{ item.name }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-6 mb-2" v-if="session.schema_app != 'CLINIC'">
                            <label class="form-label col-form-label">Divisi </label>
                            <select class="form-select" v-model="form.divisi">
                                <option value="null">Choose Divisi</option>
                                <option v-for="item in session.divisionOptions()" :key="item.ID" :value="item">
                                    {{ item.name }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-6 mb-2" v-if="session.schema_app == 'CLINIC'">
                            <label class="form-label col-form-label">Clinic </label>
                            <select class="form-select" v-model="form.clinic">
                                <option value="">Choose Clinic</option>
                                <option v-for="item in session.clinicOptions()" :key="item.ID" :value="item">
                                    {{ item.description }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-6 mb-2">
                            <label class="form-label col-form-label">Username</label>
                            <input v-model="form.username" type="text" class="form-control">
                        </div>
                        <div class="col-md-6 mb-2">
                            <label class="form-label col-form-label">Email</label>
                            <input v-model="form.email" type="email" class="form-control" >
                        </div>
                        <div class="col-md-6 mb-2">
                            <label class="form-label col-form-label">Firstname</label>
                            <input v-model="form.firstname" type="text" class="form-control">
                        </div>
                        <div class="col-md-6 mb-2">
                            <label class="form-label col-form-label">Lastname</label>
                            <input v-model="form.lastname" type="text" class="form-control">
                        </div>
                        <div class="col-md-6 mb-2">
                            <label class="form-label col-form-label">Password</label>
                            <input v-model="form.password" type="password" class="form-control"
                                placeholder="************">
                        </div>
                        <div class="col-md-6 mb-2">
                            <label class="form-label col-form-label">Avatar URL</label>
                            <Upload pathFile="/user"
                                @on-success="(event: string) => handleImageUpload(event)"
                                @on-change="(event: string) => handleImageUpload(event)"></Upload>
                            <!-- <input v-model="form.avatarurl" type="text" class="form-control"> -->
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-danger" type="button" @click="closeModal">Cancel</button>
                    <button class="btn btn-primary" type="submit" @click="saveUser">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, reactive, onMounted, defineAsyncComponent } from 'vue'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import DataTable from '@/components/table/Datatable.vue'
const Upload = defineAsyncComponent(() => import("@/components/input/Uploads.vue"))
import { Modal } from 'bootstrap'
import { useSessionStore } from '@/store/session';
const session = useSessionStore()

const users = ref<any[]>([])
const loading = ref(false)
const total = ref(0)
const modalTitle = ref('')
const params = reactive<DataTableParams>({
    page: 1,
    size: 10,
    search: ''
})
const headers = ref<any[]>([])
if (session.schema_app == 'CLINIC') {
    headers.value = [
        { text: 'profile', value: 'avatarurl' },
        { text: 'Clinic', value: 'clinic' },
        { text: 'Nickname', value: 'nickname' },
        { text: 'Email', value: 'email' },
        { text: 'Username', value: 'username' },
        { text: 'Role', value: 'role' },
        { text: 'Provider', value: 'provider' },
        { text: 'Actions', value: 'actions' }
    ]
} else {
    headers.value = [
        { text: 'profile', value: 'avatarurl' },
        { text: 'Nickname', value: 'nickname' },
        { text: 'Email', value: 'email' },
        { text: 'Username', value: 'username' },
        { text: 'Role', value: 'role' },
        { text: 'Divisi', value: 'divisi_name' },
        { text: 'Provider', value: 'provider' },
        { text: 'Actions', value: 'actions' }
    ]
}

const initForm = {
    ID: null,
    provider: '',
    username: '',
    email: '',
    password: '',
    role: null,
    divisi: null,
    clinic: null,
    firstname: '',
    lastname: '',
    nickname: '',
    description: '',
    user_id: '',
    avatarurl: '',
    location: '',
    status: false,
}

const form = reactive({
    ...initForm
})

import * as setting from "@/api/services/SettingRequest";

const roleOptions = ref<any[]>([])
const fetchRoles = async () => {
    try {
        const resp = await setting.postRequest("/role/list", { page: 1, size: 10000, search: '' });
        roleOptions.value = resp.data;

    } catch (error) {
        toast.error('Failed to fetch users')
    }
}

const fetchUsers = async () => {
    loading.value = true
    try {
        const resp = await setting.postRequest("/user/list", params);
        if (resp.status !== 200) throw new Error('Failed to fetch users')
        users.value = resp.data
        total.value = resp.total

    } catch (error) {
        toast.error('Failed to fetch users')
    }
    loading.value = false
}

const updateParams = (newParams: Partial<DataTableParams>) => {
    console.log(newParams)
    Object.assign(params, newParams)
    console.log(params)
    fetchUsers()
}

const modalRef = ref<HTMLElement | null>(null)
let bsModal: any | null = null

const viewModalRef = ref<HTMLElement | null>(null)
let bsViewModal: any | null = null

onMounted(() => {
    if (modalRef.value) {
        bsModal = new Modal(modalRef.value)
    }
    if (viewModalRef.value) {
        bsViewModal = new Modal(viewModalRef.value)
    }

    fetchUsers()
    fetchRoles()
})

const closeModal = () => {
    if (bsModal) {
        bsModal.hide()
    }
}

const editUser = (user: any) => {
    openModal(user);
}

const saveUser = async () => {
    loading.value = true
    try {
        if (form.ID) {
            await setting.postRequest("/user/update", form).then((resp) => {
                if (resp.status === 200) {
                    toast.success('User updated successfully');
                    closeModal();
                    fetchUsers();
                } else {
                    toast.error('Failed to update user');
                }
            }).catch((error) => {
                toast.error(error.message || 'Failed to update user');
            })
        } else {
            await setting.postRequest("/user/create", form).then((resp) => {
                if (resp.status === 200) {
                    toast.success('User created successfully');
                    closeModal();
                    fetchUsers();
                } else {
                    toast.error('Failed to create user');
                }
            }).catch((error) => {
                toast.error(error.message || 'Failed to create user');
            })
        }
    } catch (error: any) {
        toast.error(error.message || 'Failed to save user');
    } finally {
        loading.value = false
    }
}

const deleteUser = async (user: any) => {
    if (!confirm('Are you sure you want to delete this user?')) return

    loading.value = true
    try {
        await setting.postRequest("/user/delete", { ID: user.ID }).then((resp) => {
            if (resp.status === 200) {
                toast.success('User deleted successfully');
                closeModal();
                fetchUsers();
            } else {
                toast.error('Failed to delete user');
            }
        })

    } catch (error: any) {
        toast.error(error.message || 'Failed to delete user');
    } finally {
        loading.value = false
    }
}

const openModal = (user: any | null = null) => {
    if (user) {
        modalTitle.value = 'Edit User'
        Object.assign(form, user);
        form.password = ''
        if (form.clinic_id != null) {
            form.clinic = session.clinicOptions().find(c => c.ID === form.clinic_id)
        }
        form.divisi = session.divisionOptions().find(d => d.name === user.divisi_name)
    } else {
        modalTitle.value = 'Create User'
        Object.assign(form, { ...initForm })
    }
    if (bsModal) {
        bsModal.show()
    }
}

// Image upload handler
const handleImageUpload = (event: string) => {
    form.avatarurl = event as string;
}
</script>